/* tslint:disable */
/* eslint-disable */
/**
 * PID Backoffice Gateway definition for PFS Advisor Definition, external
 * Defines relations between advisors and clients, external
 *
 * The version of the OpenAPI document: 4.11
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddressV4
 */
export interface AddressV4 {
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'buildingApartment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'streetNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'evidenceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'houseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'cityPart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressV4
     */
    'zipcode': string;
    /**
     * 
     * @type {CountryCodeV2x0}
     * @memberof AddressV4
     */
    'country': CountryCodeV2x0;
}


/**
 * 
 * @export
 * @interface AdvisorClientV4
 */
export interface AdvisorClientV4 {
    /**
     * 
     * @type {string}
     * @memberof AdvisorClientV4
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorClientV4
     */
    'givenName': string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorClientV4
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorClientV4
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorClientV4
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdvisorClientV4
     */
    'idCardNumber'?: string | null;
    /**
     * 
     * @type {PhoneV2x0}
     * @memberof AdvisorClientV4
     */
    'phone'?: PhoneV2x0;
    /**
     * 
     * @type {EmailV2x0}
     * @memberof AdvisorClientV4
     */
    'email'?: EmailV2x0;
    /**
     * 
     * @type {AddressV4}
     * @memberof AdvisorClientV4
     */
    'permanentAddress'?: AddressV4;
}
/**
 * Deprecated, replaced by AdvisorRight2. List of possible rights of the advisor towards clients. 
 * @export
 * @enum {string}
 */

export const AdvisorRight1V1x1 = {
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW',
    DATA_BANK_ACCOUNTS_DETAIL: 'DATA_BANK_ACCOUNTS_DETAIL',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW'
} as const;

export type AdvisorRight1V1x1 = typeof AdvisorRight1V1x1[keyof typeof AdvisorRight1V1x1];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight21V1x1 = {
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW',
    DATA_BANK_ACCOUNTS_DETAIL: 'DATA_BANK_ACCOUNTS_DETAIL',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE'
} as const;

export type AdvisorRight21V1x1 = typeof AdvisorRight21V1x1[keyof typeof AdvisorRight21V1x1];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight2V2x9 = {
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW'
} as const;

export type AdvisorRight2V2x9 = typeof AdvisorRight2V2x9[keyof typeof AdvisorRight2V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight3V2x9 = {
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW',
    RQ_BANK_LOANS_VIEW: 'RQ_BANK_LOANS_VIEW'
} as const;

export type AdvisorRight3V2x9 = typeof AdvisorRight3V2x9[keyof typeof AdvisorRight3V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight4V2x9 = {
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW',
    RQ_BANK_LOANS_VIEW: 'RQ_BANK_LOANS_VIEW',
    RQ_BANK_ACCOUNTS_BLOCK: 'RQ_BANK_ACCOUNTS_BLOCK'
} as const;

export type AdvisorRight4V2x9 = typeof AdvisorRight4V2x9[keyof typeof AdvisorRight4V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight5V2x9 = {
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW',
    RQ_BANK_LOANS_VIEW: 'RQ_BANK_LOANS_VIEW',
    RQ_BANK_ACCOUNTS_BLOCK: 'RQ_BANK_ACCOUNTS_BLOCK',
    RQ_BANK_IDENTITY_VIEW: 'RQ_BANK_IDENTITY_VIEW'
} as const;

export type AdvisorRight5V2x9 = typeof AdvisorRight5V2x9[keyof typeof AdvisorRight5V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight6V2x9 = {
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_BANK_ACCOUNTS_BLOCK: 'RQ_BANK_ACCOUNTS_BLOCK',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_IDENTITY_VIEW: 'RQ_BANK_IDENTITY_VIEW',
    RQ_BANK_LOANS_VIEW: 'RQ_BANK_LOANS_VIEW',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_PSD2_VIEW: 'RQ_BANK_PSD2_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW'
} as const;

export type AdvisorRight6V2x9 = typeof AdvisorRight6V2x9[keyof typeof AdvisorRight6V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight7V2x9 = {
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_BANK_ACCOUNTS_BLOCK: 'RQ_BANK_ACCOUNTS_BLOCK',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_IDENTITY_VIEW: 'RQ_BANK_IDENTITY_VIEW',
    RQ_BANK_LOANS_VIEW: 'RQ_BANK_LOANS_VIEW',
    RQ_BANK_MARKETING_CAMPAIGNS_VIEW: 'RQ_BANK_MARKETING_CAMPAIGNS_VIEW',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_PSD2_VIEW: 'RQ_BANK_PSD2_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW'
} as const;

export type AdvisorRight7V2x9 = typeof AdvisorRight7V2x9[keyof typeof AdvisorRight7V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight8V2x9 = {
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_BANK_ACCOUNTS_BLOCK: 'RQ_BANK_ACCOUNTS_BLOCK',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_IDENTITY_VIEW: 'RQ_BANK_IDENTITY_VIEW',
    RQ_BANK_INSURANCE_VIEW: 'RQ_BANK_INSURANCE_VIEW',
    RQ_BANK_LOANS_VIEW: 'RQ_BANK_LOANS_VIEW',
    RQ_BANK_MARKETING_CAMPAIGNS_VIEW: 'RQ_BANK_MARKETING_CAMPAIGNS_VIEW',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_PSD2_VIEW: 'RQ_BANK_PSD2_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW'
} as const;

export type AdvisorRight8V2x9 = typeof AdvisorRight8V2x9[keyof typeof AdvisorRight8V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRight9V2x9 = {
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR',
    RQ_APPLICATION_ACTIVATION_VIEW: 'RQ_APPLICATION_ACTIVATION_VIEW',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_BANK_ACCOUNTS_BLOCK: 'RQ_BANK_ACCOUNTS_BLOCK',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_CRYPTO_ACCOUNT_VIEW: 'RQ_BANK_CRYPTO_ACCOUNT_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_IDENTITY_VIEW: 'RQ_BANK_IDENTITY_VIEW',
    RQ_BANK_INSURANCE_VIEW: 'RQ_BANK_INSURANCE_VIEW',
    RQ_BANK_LOANS_VIEW: 'RQ_BANK_LOANS_VIEW',
    RQ_BANK_MARKETING_CAMPAIGNS_VIEW: 'RQ_BANK_MARKETING_CAMPAIGNS_VIEW',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_PSD2_VIEW: 'RQ_BANK_PSD2_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW'
} as const;

export type AdvisorRight9V2x9 = typeof AdvisorRight9V2x9[keyof typeof AdvisorRight9V2x9];


/**
 * List of possible rights of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRightV2x9 = {
    RQ_CLIENT_VIEW: 'RQ_CLIENT_VIEW',
    RQ_APPLICATION_VIEW: 'RQ_APPLICATION_VIEW',
    RQ_EVENTS_VIEW: 'RQ_EVENTS_VIEW',
    RQ_BANK_ACCOUNTS_VIEW: 'RQ_BANK_ACCOUNTS_VIEW',
    RQ_BANK_BUNDLE_VIEW: 'RQ_BANK_BUNDLE_VIEW',
    RQ_BANK_CARDS_VIEW: 'RQ_BANK_CARDS_VIEW',
    RQ_BANK_DOCUMENTS_VIEW: 'RQ_BANK_DOCUMENTS_VIEW',
    RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW: 'RQ_BANK_NEW_PRODUCT_REQUESTS_VIEW',
    RQ_BANK_SIGN_REQUESTS_VIEW: 'RQ_BANK_SIGN_REQUESTS_VIEW',
    RQ_SIGN_REQUESTS_VIEW: 'RQ_SIGN_REQUESTS_VIEW',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP',
    DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED: 'DATA_BANK_ACCOUNTS_DETAIL_ADVISOR_GROUP_LIMITED',
    RQ_BANK_CARDS_FREEZE: 'RQ_BANK_CARDS_FREEZE',
    RQ_BANK_CARDS_UNFREEZE: 'RQ_BANK_CARDS_UNFREEZE',
    RQ_APPLICATION_BLOCK: 'RQ_APPLICATION_BLOCK',
    RQ_APPLICATION_UNBLOCK: 'RQ_APPLICATION_UNBLOCK',
    RQ_APPLICATION_REMOVE: 'RQ_APPLICATION_REMOVE',
    RQ_BANK_MOBILITY_CREATE: 'RQ_BANK_MOBILITY_CREATE',
    RQ_BANK_MOBILITY_VIEW: 'RQ_BANK_MOBILITY_VIEW',
    RQ_BANK_DOCUMENTS_GENERATE: 'RQ_BANK_DOCUMENTS_GENERATE',
    RQ_BANK_CARDS_TOKEN_VIEW: 'RQ_BANK_CARDS_TOKEN_VIEW',
    RQ_BANK_CARDS_TOKEN_FREEZE: 'RQ_BANK_CARDS_TOKEN_FREEZE',
    RQ_BANK_CARDS_TOKEN_UNFREEZE: 'RQ_BANK_CARDS_TOKEN_UNFREEZE',
    RQ_BANK_DOCUMENTS_UPLOAD: 'RQ_BANK_DOCUMENTS_UPLOAD',
    RQ_BANK_DOCUMENTS_SET_VISIBILITY: 'RQ_BANK_DOCUMENTS_SET_VISIBILITY',
    RQ_CLIENT_VERIFY_IDENTITY: 'RQ_CLIENT_VERIFY_IDENTITY',
    RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN: 'RQ_BANK_BUNDLE_MANAGE_MARKETING_CAMPAIGN',
    RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC: 'RQ_BANK_ACCOUNTS_MARK_ACCOUNT_AS_BASIC',
    DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR: 'DATA_BANK_BUNDLE_MARKETING_CAMPAIGN_ADVISOR'
} as const;

export type AdvisorRightV2x9 = typeof AdvisorRightV2x9[keyof typeof AdvisorRightV2x9];


/**
 * List of possible roles of the advisor towards clients.
 * @export
 * @enum {string}
 */

export const AdvisorRoleV4 = {
    ADMINISTRATOR: 'ADMINISTRATOR',
    GUARDIAN: 'GUARDIAN',
    SHARED: 'SHARED',
    SERVICE: 'SERVICE',
    STRUCTURE: 'STRUCTURE',
    BUBBLE: 'BUBBLE'
} as const;

export type AdvisorRoleV4 = typeof AdvisorRoleV4[keyof typeof AdvisorRoleV4];


/**
 * 
 * @export
 * @interface ClientV4
 */
export interface ClientV4 {
    /**
     * 
     * @type {string}
     * @memberof ClientV4
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ClientV4
     */
    'givenName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientV4
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof ClientV4
     */
    'birthday': string;
    /**
     * 
     * @type {string}
     * @memberof ClientV4
     */
    'birthNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientV4
     */
    'idCardNumber'?: string | null;
    /**
     * 
     * @type {PhoneV2x0}
     * @memberof ClientV4
     */
    'phone'?: PhoneV2x0;
    /**
     * 
     * @type {EmailV2x0}
     * @memberof ClientV4
     */
    'email'?: EmailV2x0;
    /**
     * 
     * @type {AddressV4}
     * @memberof ClientV4
     */
    'permanentAddress'?: AddressV4;
}
/**
 * Nationality, ISO 3166-1 format, subtype ALPHA-3. This means three letters in uppercase.
 * @export
 * @enum {string}
 */

export const CountryCodeV2x0 = {
    UNKNOWN: 'UNKNOWN',
    ABW: 'ABW',
    AFG: 'AFG',
    AGO: 'AGO',
    AIA: 'AIA',
    ALA: 'ALA',
    ALB: 'ALB',
    AND: 'AND',
    ARE: 'ARE',
    ARG: 'ARG',
    ARM: 'ARM',
    ASM: 'ASM',
    ATA: 'ATA',
    ATF: 'ATF',
    ATG: 'ATG',
    AUS: 'AUS',
    AUT: 'AUT',
    AZE: 'AZE',
    BDI: 'BDI',
    BEL: 'BEL',
    BEN: 'BEN',
    BES: 'BES',
    BFA: 'BFA',
    BGD: 'BGD',
    BGR: 'BGR',
    BHR: 'BHR',
    BHS: 'BHS',
    BIH: 'BIH',
    BLM: 'BLM',
    BLR: 'BLR',
    BLZ: 'BLZ',
    BMU: 'BMU',
    BOL: 'BOL',
    BRA: 'BRA',
    BRB: 'BRB',
    BRN: 'BRN',
    BTN: 'BTN',
    BVT: 'BVT',
    BWA: 'BWA',
    CAF: 'CAF',
    CAN: 'CAN',
    CCK: 'CCK',
    CHE: 'CHE',
    CHL: 'CHL',
    CHN: 'CHN',
    CIV: 'CIV',
    CMR: 'CMR',
    COD: 'COD',
    COG: 'COG',
    COK: 'COK',
    COL: 'COL',
    COM: 'COM',
    CPV: 'CPV',
    CRI: 'CRI',
    CUB: 'CUB',
    CUW: 'CUW',
    CXR: 'CXR',
    CYM: 'CYM',
    CYP: 'CYP',
    CZE: 'CZE',
    DEU: 'DEU',
    DJI: 'DJI',
    DMA: 'DMA',
    DNK: 'DNK',
    DOM: 'DOM',
    DZA: 'DZA',
    ECU: 'ECU',
    EGY: 'EGY',
    ERI: 'ERI',
    ESH: 'ESH',
    ESP: 'ESP',
    EST: 'EST',
    ETH: 'ETH',
    FIN: 'FIN',
    FJI: 'FJI',
    FLK: 'FLK',
    FRA: 'FRA',
    FRO: 'FRO',
    FSM: 'FSM',
    GAB: 'GAB',
    GBR: 'GBR',
    GEO: 'GEO',
    GGY: 'GGY',
    GHA: 'GHA',
    GIB: 'GIB',
    GIN: 'GIN',
    GLP: 'GLP',
    GMB: 'GMB',
    GNB: 'GNB',
    GNQ: 'GNQ',
    GRC: 'GRC',
    GRD: 'GRD',
    GRL: 'GRL',
    GTM: 'GTM',
    GUF: 'GUF',
    GUM: 'GUM',
    GUY: 'GUY',
    HKG: 'HKG',
    HMD: 'HMD',
    HND: 'HND',
    HRV: 'HRV',
    HTI: 'HTI',
    HUN: 'HUN',
    IDN: 'IDN',
    IMN: 'IMN',
    IND: 'IND',
    IOT: 'IOT',
    IRL: 'IRL',
    IRN: 'IRN',
    IRQ: 'IRQ',
    ISL: 'ISL',
    ISR: 'ISR',
    ITA: 'ITA',
    JAM: 'JAM',
    JEY: 'JEY',
    JOR: 'JOR',
    JPN: 'JPN',
    KAZ: 'KAZ',
    KEN: 'KEN',
    KGZ: 'KGZ',
    KHM: 'KHM',
    KIR: 'KIR',
    KNA: 'KNA',
    KOR: 'KOR',
    KSV: 'KSV',
    KWT: 'KWT',
    LAO: 'LAO',
    LBN: 'LBN',
    LBR: 'LBR',
    LBY: 'LBY',
    LCA: 'LCA',
    LIE: 'LIE',
    LKA: 'LKA',
    LSO: 'LSO',
    LTU: 'LTU',
    LUX: 'LUX',
    LVA: 'LVA',
    MAC: 'MAC',
    MAF: 'MAF',
    MAR: 'MAR',
    MCO: 'MCO',
    MDA: 'MDA',
    MDG: 'MDG',
    MDV: 'MDV',
    MEX: 'MEX',
    MHL: 'MHL',
    MKD: 'MKD',
    MLI: 'MLI',
    MLT: 'MLT',
    MMR: 'MMR',
    MNE: 'MNE',
    MNG: 'MNG',
    MNP: 'MNP',
    MOZ: 'MOZ',
    MRT: 'MRT',
    MSR: 'MSR',
    MTQ: 'MTQ',
    MUS: 'MUS',
    MWI: 'MWI',
    MYS: 'MYS',
    MYT: 'MYT',
    NAM: 'NAM',
    NCL: 'NCL',
    NER: 'NER',
    NFK: 'NFK',
    NGA: 'NGA',
    NIC: 'NIC',
    NIU: 'NIU',
    NLD: 'NLD',
    NOR: 'NOR',
    NPL: 'NPL',
    NRU: 'NRU',
    NZL: 'NZL',
    OMN: 'OMN',
    PAK: 'PAK',
    PAN: 'PAN',
    PCN: 'PCN',
    PER: 'PER',
    PHL: 'PHL',
    PLW: 'PLW',
    PNG: 'PNG',
    POL: 'POL',
    PRI: 'PRI',
    PRK: 'PRK',
    PRT: 'PRT',
    PRY: 'PRY',
    PSE: 'PSE',
    PYF: 'PYF',
    QAT: 'QAT',
    REU: 'REU',
    ROU: 'ROU',
    RUS: 'RUS',
    RWA: 'RWA',
    SAU: 'SAU',
    SDN: 'SDN',
    SEN: 'SEN',
    SGP: 'SGP',
    SGS: 'SGS',
    SHN: 'SHN',
    SJM: 'SJM',
    SLB: 'SLB',
    SLE: 'SLE',
    SLV: 'SLV',
    SMR: 'SMR',
    SOM: 'SOM',
    SPM: 'SPM',
    SRB: 'SRB',
    SSD: 'SSD',
    STP: 'STP',
    SUR: 'SUR',
    SVK: 'SVK',
    SVN: 'SVN',
    SWE: 'SWE',
    SWZ: 'SWZ',
    SXM: 'SXM',
    SYC: 'SYC',
    SYR: 'SYR',
    TCA: 'TCA',
    TCD: 'TCD',
    TGO: 'TGO',
    THA: 'THA',
    TJK: 'TJK',
    TKL: 'TKL',
    TKM: 'TKM',
    TLS: 'TLS',
    TON: 'TON',
    TTO: 'TTO',
    TUN: 'TUN',
    TUR: 'TUR',
    TUV: 'TUV',
    TWN: 'TWN',
    TZA: 'TZA',
    UGA: 'UGA',
    UKR: 'UKR',
    UMI: 'UMI',
    URY: 'URY',
    USA: 'USA',
    UZB: 'UZB',
    VAT: 'VAT',
    VCT: 'VCT',
    VEN: 'VEN',
    VGB: 'VGB',
    VIR: 'VIR',
    VNM: 'VNM',
    VUT: 'VUT',
    WLF: 'WLF',
    WSM: 'WSM',
    YEM: 'YEM',
    ZAF: 'ZAF',
    ZMB: 'ZMB',
    ZWE: 'ZWE'
} as const;

export type CountryCodeV2x0 = typeof CountryCodeV2x0[keyof typeof CountryCodeV2x0];


/**
 * 
 * @export
 * @interface EmailV2x0
 */
export interface EmailV2x0 {
    /**
     * 
     * @type {string}
     * @memberof EmailV2x0
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface FindAdvisorClientResponseV4
 */
export interface FindAdvisorClientResponseV4 {
    /**
     * 
     * @type {Array<AdvisorRoleV4>}
     * @memberof FindAdvisorClientResponseV4
     */
    'roles': Array<AdvisorRoleV4>;
    /**
     * 
     * @type {string}
     * @memberof FindAdvisorClientResponseV4
     */
    'definitionTimestamp': string;
    /**
     * 
     * @type {ClientV4}
     * @memberof FindAdvisorClientResponseV4
     */
    'client': ClientV4;
}
/**
 * 
 * @export
 * @interface FindAdvisorClientsRequestV4
 */
export interface FindAdvisorClientsRequestV4 {
    /**
     * 
     * @type {Array<AdvisorRoleV4>}
     * @memberof FindAdvisorClientsRequestV4
     */
    'roles': Array<AdvisorRoleV4>;
    /**
     * 
     * @type {string}
     * @memberof FindAdvisorClientsRequestV4
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAdvisorClientsRequestV4
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAdvisorClientsRequestV4
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAdvisorClientsRequestV4
     */
    'birthDay'?: string;
    /**
     * Nation number without slash
     * @type {string}
     * @memberof FindAdvisorClientsRequestV4
     */
    'birthNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof FindAdvisorClientsRequestV4
     */
    'idCardNumber'?: string;
    /**
     * 
     * @type {PhoneV2x0}
     * @memberof FindAdvisorClientsRequestV4
     */
    'phone'?: PhoneV2x0;
    /**
     * 
     * @type {EmailV2x0}
     * @memberof FindAdvisorClientsRequestV4
     */
    'email'?: EmailV2x0;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof FindAdvisorClientsRequestV4
     */
    'pageable': PageableV1x0;
}
/**
 * 
 * @export
 * @interface FindAdvisorClientsResponseV4
 */
export interface FindAdvisorClientsResponseV4 {
    /**
     * 
     * @type {Array<AdvisorClientV4>}
     * @memberof FindAdvisorClientsResponseV4
     */
    'clients': Array<AdvisorClientV4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindAdvisorClientsResponseV4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsRequestV4
 */
export interface FindRightsDefinitionsRequestV4 {
    /**
     * 
     * @type {PageableV1x0}
     * @memberof FindRightsDefinitionsRequestV4
     */
    'pageable': PageableV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse10V4
 */
export interface FindRightsDefinitionsResponse10V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem10V4>}
     * @memberof FindRightsDefinitionsResponse10V4
     */
    'rights': Array<RightDefinitionItem10V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse10V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse11V4
 */
export interface FindRightsDefinitionsResponse11V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem11V4>}
     * @memberof FindRightsDefinitionsResponse11V4
     */
    'rights': Array<RightDefinitionItem11V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse11V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse2V4
 */
export interface FindRightsDefinitionsResponse2V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem2V4>}
     * @memberof FindRightsDefinitionsResponse2V4
     */
    'rights': Array<RightDefinitionItem2V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse2V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse3V4
 */
export interface FindRightsDefinitionsResponse3V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem3V4>}
     * @memberof FindRightsDefinitionsResponse3V4
     */
    'rights': Array<RightDefinitionItem3V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse3V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse4V4
 */
export interface FindRightsDefinitionsResponse4V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem4V4>}
     * @memberof FindRightsDefinitionsResponse4V4
     */
    'rights': Array<RightDefinitionItem4V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse4V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse5V4
 */
export interface FindRightsDefinitionsResponse5V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem5V4>}
     * @memberof FindRightsDefinitionsResponse5V4
     */
    'rights': Array<RightDefinitionItem5V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse5V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse6V4
 */
export interface FindRightsDefinitionsResponse6V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem6V4>}
     * @memberof FindRightsDefinitionsResponse6V4
     */
    'rights': Array<RightDefinitionItem6V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse6V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse7V4
 */
export interface FindRightsDefinitionsResponse7V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem7V4>}
     * @memberof FindRightsDefinitionsResponse7V4
     */
    'rights': Array<RightDefinitionItem7V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse7V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse8V4
 */
export interface FindRightsDefinitionsResponse8V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem8V4>}
     * @memberof FindRightsDefinitionsResponse8V4
     */
    'rights': Array<RightDefinitionItem8V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse8V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponse9V4
 */
export interface FindRightsDefinitionsResponse9V4 {
    /**
     * 
     * @type {Array<RightDefinitionItem9V4>}
     * @memberof FindRightsDefinitionsResponse9V4
     */
    'rights': Array<RightDefinitionItem9V4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponse9V4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @interface FindRightsDefinitionsResponseV4
 */
export interface FindRightsDefinitionsResponseV4 {
    /**
     * 
     * @type {Array<RightDefinitionItemV4>}
     * @memberof FindRightsDefinitionsResponseV4
     */
    'rights': Array<RightDefinitionItemV4>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof FindRightsDefinitionsResponseV4
     */
    'pageable': PageableResponseV1x0;
}
/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface PhoneV2x0
 */
export interface PhoneV2x0 {
    /**
     * End-User\'s preferred telephone number prefix
     * @type {string}
     * @memberof PhoneV2x0
     */
    'prefix': string;
    /**
     * End-User\'s preferred telephone number
     * @type {string}
     * @memberof PhoneV2x0
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface RightDefinitionItem10V4
 */
export interface RightDefinitionItem10V4 {
    /**
     * 
     * @type {AdvisorRight8V2x9}
     * @memberof RightDefinitionItem10V4
     */
    'right': AdvisorRight8V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem10V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem11V4
 */
export interface RightDefinitionItem11V4 {
    /**
     * 
     * @type {AdvisorRight9V2x9}
     * @memberof RightDefinitionItem11V4
     */
    'right': AdvisorRight9V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem11V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem2V4
 */
export interface RightDefinitionItem2V4 {
    /**
     * 
     * @type {AdvisorRight21V1x1}
     * @memberof RightDefinitionItem2V4
     */
    'right': AdvisorRight21V1x1;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem2V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem3V4
 */
export interface RightDefinitionItem3V4 {
    /**
     * 
     * @type {AdvisorRightV2x9}
     * @memberof RightDefinitionItem3V4
     */
    'right': AdvisorRightV2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem3V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem4V4
 */
export interface RightDefinitionItem4V4 {
    /**
     * 
     * @type {AdvisorRight2V2x9}
     * @memberof RightDefinitionItem4V4
     */
    'right': AdvisorRight2V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem4V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem5V4
 */
export interface RightDefinitionItem5V4 {
    /**
     * 
     * @type {AdvisorRight3V2x9}
     * @memberof RightDefinitionItem5V4
     */
    'right': AdvisorRight3V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem5V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem6V4
 */
export interface RightDefinitionItem6V4 {
    /**
     * 
     * @type {AdvisorRight4V2x9}
     * @memberof RightDefinitionItem6V4
     */
    'right': AdvisorRight4V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem6V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem7V4
 */
export interface RightDefinitionItem7V4 {
    /**
     * 
     * @type {AdvisorRight5V2x9}
     * @memberof RightDefinitionItem7V4
     */
    'right': AdvisorRight5V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem7V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem8V4
 */
export interface RightDefinitionItem8V4 {
    /**
     * 
     * @type {AdvisorRight6V2x9}
     * @memberof RightDefinitionItem8V4
     */
    'right': AdvisorRight6V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem8V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItem9V4
 */
export interface RightDefinitionItem9V4 {
    /**
     * 
     * @type {AdvisorRight7V2x9}
     * @memberof RightDefinitionItem9V4
     */
    'right': AdvisorRight7V2x9;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItem9V4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RightDefinitionItemV4
 */
export interface RightDefinitionItemV4 {
    /**
     * 
     * @type {AdvisorRight1V1x1}
     * @memberof RightDefinitionItemV4
     * @deprecated
     */
    'right': AdvisorRight1V1x1;
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof RightDefinitionItemV4
     */
    'roleSetup': Array<RoleSetupItemV4>;
}


/**
 * 
 * @export
 * @interface RoleSetupItemV4
 */
export interface RoleSetupItemV4 {
    /**
     * 
     * @type {AdvisorRoleV4}
     * @memberof RoleSetupItemV4
     */
    'role': AdvisorRoleV4;
    /**
     * 
     * @type {boolean}
     * @memberof RoleSetupItemV4
     */
    'allowed': boolean;
}


/**
 * 
 * @export
 * @interface UpdateRightDefinitionRequestV4
 */
export interface UpdateRightDefinitionRequestV4 {
    /**
     * 
     * @type {Array<RoleSetupItemV4>}
     * @memberof UpdateRightDefinitionRequestV4
     */
    'right': Array<RoleSetupItemV4>;
}


/**
 * AdvisorApi - axios parameter creator
 * @export
 */
export const AdvisorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all advisor’s clients (based on advisorId in access token) that  pass the advisor’s roles. 
         * @summary Definition of all advisor’s clients
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} advisorId 
         * @param {FindAdvisorClientsRequestV4} findAdvisorClientsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdvisorClientsV4: async (xCorrelationId: string, advisorId: number, findAdvisorClientsRequestV4: FindAdvisorClientsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findAdvisorClientsV4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'advisorId' is not null or undefined
            assertParamExists('findAdvisorClientsV4', 'advisorId', advisorId)
            // verify required parameter 'findAdvisorClientsRequestV4' is not null or undefined
            assertParamExists('findAdvisorClientsV4', 'findAdvisorClientsRequestV4', findAdvisorClientsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisors/{advisorId}/clients`
                .replace(`{${"advisorId"}}`, encodeURIComponent(String(advisorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findAdvisorClientsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights11. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions10V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions10V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions10V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights10`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRightsDefinitions11V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions11V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions11V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights11`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights3. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions2V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions2V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions2V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights4. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions3V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions3V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions3V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights3`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights5. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions4V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions4V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions4V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights4`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights6. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions5V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions5V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions5V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights5`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights7. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions6V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions6V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions6V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights6`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights8. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions7V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions7V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions7V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights7`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights9. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions8V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions8V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions8V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights8`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights10. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRightsDefinitions9V4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitions9V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitions9V4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights9`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights2. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitionsV4: async (xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findRightsDefinitionsV4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'findRightsDefinitionsRequestV4' is not null or undefined
            assertParamExists('findRightsDefinitionsV4', 'findRightsDefinitionsRequestV4', findRightsDefinitionsRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findRightsDefinitionsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all advisor’s roles assigned to particular client including  client’s personal data stored in the pfs-advisor-definition service. 
         * @summary Advisor definition for particular client
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} advisorId 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisorClientV4: async (xCorrelationId: string, advisorId: number, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getAdvisorClientV4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'advisorId' is not null or undefined
            assertParamExists('getAdvisorClientV4', 'advisorId', advisorId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getAdvisorClientV4', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisors/{advisorId}/clients/{pidUuid}`
                .replace(`{${"advisorId"}}`, encodeURIComponent(String(advisorId)))
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights3/{right} instead. This API will be removed after 11.7.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight2V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition2V4: async (xCorrelationId: string, right: AdvisorRight2V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition2V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition2V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition2V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights2/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights4/{right} instead. This API will be removed after 23.10.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight3V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition3V4: async (xCorrelationId: string, right: AdvisorRight3V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition3V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition3V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition3V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights3/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights5/{right} instead. This API will be removed after 25.11.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight4V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition4V4: async (xCorrelationId: string, right: AdvisorRight4V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition4V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition4V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition4V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights4/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights6/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight5V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition5V4: async (xCorrelationId: string, right: AdvisorRight5V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition5V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition5V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition5V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights5/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights7/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight6V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition6V4: async (xCorrelationId: string, right: AdvisorRight6V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition6V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition6V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition6V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights6/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights8/{right} instead. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight7V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRightDefinition7V4: async (xCorrelationId: string, right: AdvisorRight7V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition7V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition7V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition7V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights7/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights9/{right} instead. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight8V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition8V4: async (xCorrelationId: string, right: AdvisorRight8V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition8V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition8V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition8V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights8/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates one right setup for all six advisor roles (if changed).
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight9V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRightDefinition9V4: async (xCorrelationId: string, right: AdvisorRight9V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinition9V4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinition9V4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinition9V4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights9/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, use /advisor-rights2/{right} instead. This API will be removed after 29.6.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRightV2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinitionV4: async (xCorrelationId: string, right: AdvisorRightV2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('updateRightDefinitionV4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'right' is not null or undefined
            assertParamExists('updateRightDefinitionV4', 'right', right)
            // verify required parameter 'updateRightDefinitionRequestV4' is not null or undefined
            assertParamExists('updateRightDefinitionV4', 'updateRightDefinitionRequestV4', updateRightDefinitionRequestV4)
            const localVarPath = `/pid-backofficegateway-pfsadvisordefinition/v4/advisor-rights/{right}`
                .replace(`{${"right"}}`, encodeURIComponent(String(right)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRightDefinitionRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvisorApi - functional programming interface
 * @export
 */
export const AdvisorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdvisorApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all advisor’s clients (based on advisorId in access token) that  pass the advisor’s roles. 
         * @summary Definition of all advisor’s clients
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} advisorId 
         * @param {FindAdvisorClientsRequestV4} findAdvisorClientsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAdvisorClientsV4(xCorrelationId: string, advisorId: number, findAdvisorClientsRequestV4: FindAdvisorClientsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindAdvisorClientsResponseV4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAdvisorClientsV4(xCorrelationId, advisorId, findAdvisorClientsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights11. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions10V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse10V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions10V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRightsDefinitions11V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse11V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions11V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights3. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions2V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse2V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions2V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights4. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions3V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse3V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions3V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights5. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions4V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse4V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions4V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights6. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions5V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse5V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions5V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights7. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions6V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse6V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions6V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights8. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions7V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse7V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions7V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights9. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitions8V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse8V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions8V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights10. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRightsDefinitions9V4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponse9V4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitions9V4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights2. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {FindRightsDefinitionsRequestV4} findRightsDefinitionsRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async findRightsDefinitionsV4(xCorrelationId: string, findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindRightsDefinitionsResponseV4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRightsDefinitionsV4(xCorrelationId, findRightsDefinitionsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all advisor’s roles assigned to particular client including  client’s personal data stored in the pfs-advisor-definition service. 
         * @summary Advisor definition for particular client
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} advisorId 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvisorClientV4(xCorrelationId: string, advisorId: number, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindAdvisorClientResponseV4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvisorClientV4(xCorrelationId, advisorId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights3/{right} instead. This API will be removed after 11.7.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight2V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateRightDefinition2V4(xCorrelationId: string, right: AdvisorRight2V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition2V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights4/{right} instead. This API will be removed after 23.10.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight3V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateRightDefinition3V4(xCorrelationId: string, right: AdvisorRight3V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition3V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights5/{right} instead. This API will be removed after 25.11.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight4V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateRightDefinition4V4(xCorrelationId: string, right: AdvisorRight4V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition4V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights6/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight5V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateRightDefinition5V4(xCorrelationId: string, right: AdvisorRight5V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition5V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights7/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight6V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateRightDefinition6V4(xCorrelationId: string, right: AdvisorRight6V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition6V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights8/{right} instead. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight7V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRightDefinition7V4(xCorrelationId: string, right: AdvisorRight7V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition7V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights9/{right} instead. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight8V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateRightDefinition8V4(xCorrelationId: string, right: AdvisorRight8V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition8V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates one right setup for all six advisor roles (if changed).
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRight9V2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRightDefinition9V4(xCorrelationId: string, right: AdvisorRight9V2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinition9V4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, use /advisor-rights2/{right} instead. This API will be removed after 29.6.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {AdvisorRightV2x9} right 
         * @param {UpdateRightDefinitionRequestV4} updateRightDefinitionRequestV4 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateRightDefinitionV4(xCorrelationId: string, right: AdvisorRightV2x9, updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRightDefinitionV4(xCorrelationId, right, updateRightDefinitionRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdvisorApi - factory interface
 * @export
 */
export const AdvisorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdvisorApiFp(configuration)
    return {
        /**
         * Returns all advisor’s clients (based on advisorId in access token) that  pass the advisor’s roles. 
         * @summary Definition of all advisor’s clients
         * @param {AdvisorApiFindAdvisorClientsV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdvisorClientsV4(requestParameters: AdvisorApiFindAdvisorClientsV4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindAdvisorClientsResponseV4> {
            return localVarFp.findAdvisorClientsV4(requestParameters.xCorrelationId, requestParameters.advisorId, requestParameters.findAdvisorClientsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights11. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions10V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions10V4(requestParameters: AdvisorApiFindRightsDefinitions10V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse10V4> {
            return localVarFp.findRightsDefinitions10V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions11V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRightsDefinitions11V4(requestParameters: AdvisorApiFindRightsDefinitions11V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse11V4> {
            return localVarFp.findRightsDefinitions11V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights3. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions2V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions2V4(requestParameters: AdvisorApiFindRightsDefinitions2V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse2V4> {
            return localVarFp.findRightsDefinitions2V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights4. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions3V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions3V4(requestParameters: AdvisorApiFindRightsDefinitions3V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse3V4> {
            return localVarFp.findRightsDefinitions3V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights5. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions4V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions4V4(requestParameters: AdvisorApiFindRightsDefinitions4V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse4V4> {
            return localVarFp.findRightsDefinitions4V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights6. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions5V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions5V4(requestParameters: AdvisorApiFindRightsDefinitions5V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse5V4> {
            return localVarFp.findRightsDefinitions5V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights7. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions6V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions6V4(requestParameters: AdvisorApiFindRightsDefinitions6V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse6V4> {
            return localVarFp.findRightsDefinitions6V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights8. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions7V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions7V4(requestParameters: AdvisorApiFindRightsDefinitions7V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse7V4> {
            return localVarFp.findRightsDefinitions7V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights9. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions8V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitions8V4(requestParameters: AdvisorApiFindRightsDefinitions8V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse8V4> {
            return localVarFp.findRightsDefinitions8V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights10. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitions9V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRightsDefinitions9V4(requestParameters: AdvisorApiFindRightsDefinitions9V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponse9V4> {
            return localVarFp.findRightsDefinitions9V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated due to AdvisorRight enum extension. Use /advisor-rights2. Returns setup of Back Office application rights for each advisor role. 
         * @summary Rights setup for each advisor role
         * @param {AdvisorApiFindRightsDefinitionsV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        findRightsDefinitionsV4(requestParameters: AdvisorApiFindRightsDefinitionsV4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindRightsDefinitionsResponseV4> {
            return localVarFp.findRightsDefinitionsV4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Returns all advisor’s roles assigned to particular client including  client’s personal data stored in the pfs-advisor-definition service. 
         * @summary Advisor definition for particular client
         * @param {AdvisorApiGetAdvisorClientV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvisorClientV4(requestParameters: AdvisorApiGetAdvisorClientV4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindAdvisorClientResponseV4> {
            return localVarFp.getAdvisorClientV4(requestParameters.xCorrelationId, requestParameters.advisorId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights3/{right} instead. This API will be removed after 11.7.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition2V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition2V4(requestParameters: AdvisorApiUpdateRightDefinition2V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition2V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights4/{right} instead. This API will be removed after 23.10.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition3V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition3V4(requestParameters: AdvisorApiUpdateRightDefinition3V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition3V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights5/{right} instead. This API will be removed after 25.11.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition4V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition4V4(requestParameters: AdvisorApiUpdateRightDefinition4V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition4V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights6/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition5V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition5V4(requestParameters: AdvisorApiUpdateRightDefinition5V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition5V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights7/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition6V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition6V4(requestParameters: AdvisorApiUpdateRightDefinition6V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition6V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights8/{right} instead. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition7V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRightDefinition7V4(requestParameters: AdvisorApiUpdateRightDefinition7V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition7V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights9/{right} instead. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition8V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinition8V4(requestParameters: AdvisorApiUpdateRightDefinition8V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition8V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Updates one right setup for all six advisor roles (if changed).
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinition9V4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRightDefinition9V4(requestParameters: AdvisorApiUpdateRightDefinition9V4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinition9V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, use /advisor-rights2/{right} instead. This API will be removed after 29.6.2024. Updates one right setup for all six advisor roles (if changed). 
         * @summary Update of particular right setup
         * @param {AdvisorApiUpdateRightDefinitionV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateRightDefinitionV4(requestParameters: AdvisorApiUpdateRightDefinitionV4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.updateRightDefinitionV4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAdvisorClientsV4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindAdvisorClientsV4Request
 */
export type AdvisorApiFindAdvisorClientsV4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindAdvisorClientsV4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {number}
     * @memberof AdvisorApiFindAdvisorClientsV4
     */
    readonly advisorId: number

    /**
     * 
     * @type {FindAdvisorClientsRequestV4}
     * @memberof AdvisorApiFindAdvisorClientsV4
     */
    readonly findAdvisorClientsRequestV4: FindAdvisorClientsRequestV4
}

/**
 * Request parameters for findRightsDefinitions10V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions10V4Request
 */
export type AdvisorApiFindRightsDefinitions10V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions10V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions10V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions11V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions11V4Request
 */
export type AdvisorApiFindRightsDefinitions11V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions11V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions11V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions2V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions2V4Request
 */
export type AdvisorApiFindRightsDefinitions2V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions2V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions2V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions3V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions3V4Request
 */
export type AdvisorApiFindRightsDefinitions3V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions3V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions3V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions4V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions4V4Request
 */
export type AdvisorApiFindRightsDefinitions4V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions4V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions4V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions5V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions5V4Request
 */
export type AdvisorApiFindRightsDefinitions5V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions5V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions5V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions6V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions6V4Request
 */
export type AdvisorApiFindRightsDefinitions6V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions6V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions6V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions7V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions7V4Request
 */
export type AdvisorApiFindRightsDefinitions7V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions7V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions7V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions8V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions8V4Request
 */
export type AdvisorApiFindRightsDefinitions8V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions8V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions8V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitions9V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitions9V4Request
 */
export type AdvisorApiFindRightsDefinitions9V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitions9V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitions9V4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for findRightsDefinitionsV4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiFindRightsDefinitionsV4Request
 */
export type AdvisorApiFindRightsDefinitionsV4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiFindRightsDefinitionsV4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {FindRightsDefinitionsRequestV4}
     * @memberof AdvisorApiFindRightsDefinitionsV4
     */
    readonly findRightsDefinitionsRequestV4: FindRightsDefinitionsRequestV4
}

/**
 * Request parameters for getAdvisorClientV4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiGetAdvisorClientV4Request
 */
export type AdvisorApiGetAdvisorClientV4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiGetAdvisorClientV4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {number}
     * @memberof AdvisorApiGetAdvisorClientV4
     */
    readonly advisorId: number

    /**
     * 
     * @type {string}
     * @memberof AdvisorApiGetAdvisorClientV4
     */
    readonly pidUuid: string
}

/**
 * Request parameters for updateRightDefinition2V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition2V4Request
 */
export type AdvisorApiUpdateRightDefinition2V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition2V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight2V2x9}
     * @memberof AdvisorApiUpdateRightDefinition2V4
     */
    readonly right: AdvisorRight2V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition2V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinition3V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition3V4Request
 */
export type AdvisorApiUpdateRightDefinition3V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition3V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight3V2x9}
     * @memberof AdvisorApiUpdateRightDefinition3V4
     */
    readonly right: AdvisorRight3V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition3V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinition4V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition4V4Request
 */
export type AdvisorApiUpdateRightDefinition4V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition4V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight4V2x9}
     * @memberof AdvisorApiUpdateRightDefinition4V4
     */
    readonly right: AdvisorRight4V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition4V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinition5V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition5V4Request
 */
export type AdvisorApiUpdateRightDefinition5V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition5V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight5V2x9}
     * @memberof AdvisorApiUpdateRightDefinition5V4
     */
    readonly right: AdvisorRight5V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition5V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinition6V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition6V4Request
 */
export type AdvisorApiUpdateRightDefinition6V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition6V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight6V2x9}
     * @memberof AdvisorApiUpdateRightDefinition6V4
     */
    readonly right: AdvisorRight6V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition6V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinition7V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition7V4Request
 */
export type AdvisorApiUpdateRightDefinition7V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition7V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight7V2x9}
     * @memberof AdvisorApiUpdateRightDefinition7V4
     */
    readonly right: AdvisorRight7V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition7V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinition8V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition8V4Request
 */
export type AdvisorApiUpdateRightDefinition8V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition8V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight8V2x9}
     * @memberof AdvisorApiUpdateRightDefinition8V4
     */
    readonly right: AdvisorRight8V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition8V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinition9V4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinition9V4Request
 */
export type AdvisorApiUpdateRightDefinition9V4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinition9V4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRight9V2x9}
     * @memberof AdvisorApiUpdateRightDefinition9V4
     */
    readonly right: AdvisorRight9V2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinition9V4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * Request parameters for updateRightDefinitionV4 operation in AdvisorApi.
 * @export
 * @type AdvisorApiUpdateRightDefinitionV4Request
 */
export type AdvisorApiUpdateRightDefinitionV4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof AdvisorApiUpdateRightDefinitionV4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {AdvisorRightV2x9}
     * @memberof AdvisorApiUpdateRightDefinitionV4
     */
    readonly right: AdvisorRightV2x9

    /**
     * 
     * @type {UpdateRightDefinitionRequestV4}
     * @memberof AdvisorApiUpdateRightDefinitionV4
     */
    readonly updateRightDefinitionRequestV4: UpdateRightDefinitionRequestV4
}

/**
 * AdvisorApi - object-oriented interface
 * @export
 * @class AdvisorApi
 * @extends {BaseAPI}
 */
export class AdvisorApi extends BaseAPI {
    /**
     * Returns all advisor’s clients (based on advisorId in access token) that  pass the advisor’s roles. 
     * @summary Definition of all advisor’s clients
     * @param {AdvisorApiFindAdvisorClientsV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findAdvisorClientsV4(requestParameters: AdvisorApiFindAdvisorClientsV4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findAdvisorClientsV4(requestParameters.xCorrelationId, requestParameters.advisorId, requestParameters.findAdvisorClientsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights11. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions10V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions10V4(requestParameters: AdvisorApiFindRightsDefinitions10V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions10V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions11V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions11V4(requestParameters: AdvisorApiFindRightsDefinitions11V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions11V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights3. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions2V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions2V4(requestParameters: AdvisorApiFindRightsDefinitions2V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions2V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights4. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions3V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions3V4(requestParameters: AdvisorApiFindRightsDefinitions3V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions3V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights5. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions4V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions4V4(requestParameters: AdvisorApiFindRightsDefinitions4V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions4V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights6. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions5V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions5V4(requestParameters: AdvisorApiFindRightsDefinitions5V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions5V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights7. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions6V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions6V4(requestParameters: AdvisorApiFindRightsDefinitions6V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions6V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights8. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions7V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions7V4(requestParameters: AdvisorApiFindRightsDefinitions7V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions7V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights9. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions8V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions8V4(requestParameters: AdvisorApiFindRightsDefinitions8V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions8V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights10. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitions9V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitions9V4(requestParameters: AdvisorApiFindRightsDefinitions9V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitions9V4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated due to AdvisorRight enum extension. Use /advisor-rights2. Returns setup of Back Office application rights for each advisor role. 
     * @summary Rights setup for each advisor role
     * @param {AdvisorApiFindRightsDefinitionsV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public findRightsDefinitionsV4(requestParameters: AdvisorApiFindRightsDefinitionsV4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).findRightsDefinitionsV4(requestParameters.xCorrelationId, requestParameters.findRightsDefinitionsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all advisor’s roles assigned to particular client including  client’s personal data stored in the pfs-advisor-definition service. 
     * @summary Advisor definition for particular client
     * @param {AdvisorApiGetAdvisorClientV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public getAdvisorClientV4(requestParameters: AdvisorApiGetAdvisorClientV4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).getAdvisorClientV4(requestParameters.xCorrelationId, requestParameters.advisorId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights3/{right} instead. This API will be removed after 11.7.2024. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition2V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition2V4(requestParameters: AdvisorApiUpdateRightDefinition2V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition2V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights4/{right} instead. This API will be removed after 23.10.2024. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition3V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition3V4(requestParameters: AdvisorApiUpdateRightDefinition3V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition3V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights5/{right} instead. This API will be removed after 25.11.2024. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition4V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition4V4(requestParameters: AdvisorApiUpdateRightDefinition4V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition4V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights6/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition5V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition5V4(requestParameters: AdvisorApiUpdateRightDefinition5V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition5V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights7/{right} instead. This API will be removed after 25.7.2025. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition6V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition6V4(requestParameters: AdvisorApiUpdateRightDefinition6V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition6V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights8/{right} instead. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition7V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition7V4(requestParameters: AdvisorApiUpdateRightDefinition7V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition7V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights9/{right} instead. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition8V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition8V4(requestParameters: AdvisorApiUpdateRightDefinition8V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition8V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates one right setup for all six advisor roles (if changed).
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinition9V4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinition9V4(requestParameters: AdvisorApiUpdateRightDefinition9V4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinition9V4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, use /advisor-rights2/{right} instead. This API will be removed after 29.6.2024. Updates one right setup for all six advisor roles (if changed). 
     * @summary Update of particular right setup
     * @param {AdvisorApiUpdateRightDefinitionV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AdvisorApi
     */
    public updateRightDefinitionV4(requestParameters: AdvisorApiUpdateRightDefinitionV4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return AdvisorApiFp(this.configuration).updateRightDefinitionV4(requestParameters.xCorrelationId, requestParameters.right, requestParameters.updateRightDefinitionRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


